import { render } from "./HospitalDash.vue?vue&type=template&id=6de41494&scoped=true"
import script from "./HospitalDash.vue?vue&type=script&lang=js"
export * from "./HospitalDash.vue?vue&type=script&lang=js"

import "./HospitalDash.vue?vue&type=style&index=0&id=6de41494&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de41494"]])

export default __exports__